import { getApiBaseUrl } from '../data/authStorage';
import httpClient from './httpClient';

const baseUrl = getApiBaseUrl();

/**
 * Refresh birthday celebrants cache from employee profile data
 */
export async function refreshBirthdayCelebrants() {
  try {
    const response = await httpClient.post(
      `${baseUrl}/organizations/celebrants/birthdays/refresh`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Get birthdays for current month
 */
export async function getCurrentMonthBirthdays(params = {}) {
  try {
    const { page = 1, limit = 10 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/celebrants/birthdays/current-month?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Get birthdays for a specific month (1-12)
 */
export async function getBirthdaysForMonth(month, params = {}) {
  try {
    const { page = 1, limit = 20 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/celebrants/birthdays?month=${month}&page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
